import store from '../store';
import { AppConfig } from '@config';
const can = store.getters['user/can'];
class Page {

    /**
     * Set document title based on route title
     * @param {Route} route
     * @param {Object} user
     */
    static title(route) {
        document.title = route.meta.title(route) + ' | ' + AppConfig.name;
    }

    /**
     * get appropriate route for 2fa authenication
     *
     * @param {Object} user
     * @returns {Route}
     */

    static needsAuthenticatorRoute(user) {
        if ( user.otp_enabled === false) {
            return {name: 'two-factor-authentication'};
        }
        else if (user.otp_authorized === false ) {
            return {name: 'two-factor-authentication-qr'};
        }

        return false;

    }

    /**
     * Check if user is logged in
     *
     * @param {Route} to
     * @param {Route} from
     * @param {Function} next
     */
    static controlRouting(to, from, next) {

        if ( to.meta && to.meta.private ) {

            store.dispatch('user/authorized').then( (user) => {
                const nextPage = Page.needsAuthenticatorRoute(user);
                if (nextPage) {
                    next(nextPage);

                } else {

                    if(to.name === 'statistics' && !can('Dashboard bekijken') ){
                        next({name: 'dashboard'});
                    }

                    Page.title(to);
                    next();
                }
            });
        }
        else {
            Page.title(to);
            next();
        }

    }
}

export default Page;
